import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Button } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import * as React from "react";
import { tokens } from "styles/Tokens";
import NestedMenu from "./NestedMenu";

const ITEM_HEIGHT = 48;

interface Props {
  disabled?: boolean;
  options?: any;
  value?: {};
  sx?: any;
  isDisabled?: boolean;
  label?: string;
}

export default function KebabMenu(props: Props) {
  const { disabled, options = [{ label: "" }], value, sx, isDisabled = false, label } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!isDisabled) {
      event.stopPropagation();
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {label ? (
        <Button
          variant="outlined"
          disableRipple
          disabled={disabled}
          aria-label="more"
          id="long-button"
          aria-controls={open ? "long-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleClick}
          endIcon={<MoreVertIcon />}
          sx={{
            border: open ? `solid ${tokens.Border.General.Tertiary}` : "solid transparent",
            borderRadius: "8px",
            height: "34px",
            margin: 0,
            "&.MuiButtonBase-root:hover": {
              backgroundColor: "inherit",
              borderRadius: "8px",
              border: `solid ${tokens.Border.General.Tertiary}`,
              outline: "0"
            }
          }}
        >
          {label}
        </Button>
      ) : (
        <IconButton
          disableRipple
          disabled={disabled}
          aria-label="more"
          id="long-button"
          aria-controls={open ? "long-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleClick}
          sx={sx}
        >
          <MoreVertIcon />
        </IconButton>
      )}

      <NestedMenu
        open={open}
        anchorEl={anchorEl}
        PaperProps={{
          sx: {
            marginY: "8px",
            borderRadius: "8px",
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "25ch",
            color: tokens.Text.General.PrimaryBody,
            fontVariant: "body2",
            "& .MuiMenuItem-root:hover": {
              backgroundColor: tokens.Background.General.Color,
              color: `${tokens.Text.General.Color} !important`,
              ".icon-svg": {
                stroke: tokens.Text.General.Color
              }
            }
          }
        }}
        disablePortal
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button"
        }}
        value={value}
        onClose={handleClose}
        configuration={options}
      />
    </>
  );
}
